'use client';

import { createContext } from 'react';

import { useScreen } from '@/shared/hooks';

type ScreenContextProps = ReturnType<typeof useScreen>;

export const ScreenContext = createContext<ScreenContextProps>({
	xs: true,
	sm: false,
	md: false,
	lg: false,
	xl: false,
});

export function ScreenProvider({ children }: React.PropsWithChildren) {
	const value = useScreen();

	return (
		<ScreenContext.Provider value={value}>{children}</ScreenContext.Provider>
	);
}
